module.exports = __webpack_public_path__ + "static/media/haruno.842ec8f0.png";